import { render, staticRenderFns } from "./ObituariesWidget.vue?vue&type=template&id=2ef48009&"
import script from "./ObituariesWidget.vue?vue&type=script&lang=ts&"
export * from "./ObituariesWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports